(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterGrid', rmsListFilterGrid);

    function rmsListFilterGrid($window, lodash) {
        return {
            restrict: 'E',
            scope: {
                grid: '='
            },
            controller: rmsListFilterGridCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/grid',
            link: rmsListFilterGridLink
        };

        function rmsListFilterGridLink(scope, elem) {
            const vm = scope.vm,
                kendoGridObj = vm.pageData.grid;

            angular.element($window).on('resize', () => {
                kendoGridObj.resize();
            });

            if (lodash.has(vm.pageData, 'gridOption.remove_grid_content_height_style') && vm.pageData.gridOption.remove_grid_content_height_style) {
                elem.find('.k-grid-content').removeAttr('style');
            }

            scope.$on('$destroy', () => {
                angular.element($window).off('resize');
            });
        }
    }

    function rmsListFilterGridCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};
            vm.dataItemAction = dataItemAction;
            vm.dataItemClass = dataItemClass;
            vm.showButton = showButton;
            vm.showChildInfo = showChildInfo;
            vm.showSection = showButton;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
        }

        function dataItemAction(action, dataItem) {
            if (action === 'preview') {
                $scope.listFilterService.showDetailView(dataItem);
            } else {
                $scope.listFilterService.emitDataItemEvent(action, dataItem);
            }
        }

        function dataItemClass(action, dataItem) {
            var buttonVisibility = $scope.listFilterService.getRowButtonVisibility(action, dataItem);
            return (buttonVisibility) ? '' : 'grid-cell-icon-hidden';
        }

        function showButton(type, dataItem) {
            return $scope.listFilterService.getRowButtonVisibility(type, dataItem);
        }

        function showChildInfo(valueKey, ruleCheck, dataItem) {
            return $scope.listFilterService.getChildInfoVisibility(valueKey, ruleCheck, dataItem);
        }
    }
})();
